"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStateProps = exports.setInternalProps = exports.setFileListToolsExternalProps = void 0;
exports.isArchiveDisabled = isArchiveDisabled;
exports.getSourceName = getSourceName;
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var permissions_1 = require("@caddigital/sok-reducers/lib/utils/permissions");
function isArchiveDisabled(currentFolder, selectedItem, archiveStatusMeta) {
    if (currentFolder === null) {
        return true;
    }
    else if ((currentFolder.perm & permissions_1.ACL_WRITE) === 0) {
        return true;
    }
    else if (((selectedItem.feature || 0x00) & acl.SUBPROJECT_PERM) === 0) {
        return true;
    }
    else if (archiveStatusMeta === undefined ||
        (archiveStatusMeta && archiveStatusMeta.id === undefined)) {
        return true;
    }
    var status = (archiveStatusMeta.options || []).find(function (x) { return x.name === 'archived'; });
    if (!status) {
        return true;
    }
    if (selectedItem.customMeta["".concat(archiveStatusMeta.id)] === status.value) {
        return true;
    }
    return false;
}
var isUserSuperAdmin = function (user) {
    return user
        .map(function (_a) {
        var level = _a.level;
        return level === 'SuperAdminUserGroup';
    })
        .getOrElse(false);
};
var isUserGranoAdmin = function (props, user) {
    var perm = props.currentProject
        ? props.currentProject.perm & ~acl.FEATURE_MASK
        : 0x00;
    var isGranoAdmin = !!(perm & acl.PROJECT_ADMIN_GRANT) ||
        user
            .map(function (_a) {
            var level = _a.level;
            return level === 'SuperAdminUserGroup' ||
                level === 'SalesmanUserGroup' ||
                level === 'ProjectAdmin' ||
                false;
        })
            .getOrElse(false);
    return isGranoAdmin;
};
var archiveStatusMeta = function (metadata) {
    return metadata === null || metadata === void 0 ? void 0 : metadata.list.find(function (metadata) {
        return metadata.identifier === 'subproject-status-meta';
    });
};
var setFileListToolsExternalProps = function (props, user) {
    return {
        addItemsToCart: props.addItemsToCart,
        toggleUploadModal: props.toggleUploadModal,
        currentBid: props.currentBid,
        isGranoAdmin: isUserGranoAdmin(props, user),
        isSuperAdmin: isUserSuperAdmin(user),
        archiveStatusMeta: archiveStatusMeta(props.metadata),
        currentProject: props.currentProject,
        isMobile: props.isMobile,
        metadata: props.metadata
    };
};
exports.setFileListToolsExternalProps = setFileListToolsExternalProps;
var setInternalProps = function (removeIsOpen, setRemoveIsOpen, createSubprojectIsOpen, setCreateSubprojectIsOpen, archiveSubprojectIsOpen, setArchiveSubprojectIsOpen) {
    return {
        removeIsOpen: removeIsOpen,
        setRemoveIsOpen: setRemoveIsOpen,
        createSubprojectIsOpen: createSubprojectIsOpen,
        setCreateSubprojectIsOpen: setCreateSubprojectIsOpen,
        archiveSubprojectIsOpen: archiveSubprojectIsOpen,
        setArchiveSubprojectIsOpen: setArchiveSubprojectIsOpen
    };
};
exports.setInternalProps = setInternalProps;
var setStateProps = function (properties, currentFolder, selectedItems, folderPath) {
    return {
        ttl: properties.mode === 'TTL' ? properties.ttl : undefined,
        status: properties.status,
        mode: properties.mode,
        currentFolder: currentFolder,
        selectedItems: selectedItems,
        folderPath: folderPath
    };
};
exports.setStateProps = setStateProps;
function getSourceName(currentFolder, parent) {
    if (currentFolder && currentFolder.name !== 'Root') {
        return currentFolder.name;
    }
    return parent.name;
}
